import classes from './P2PAdminPanel.module.css';

const SidebarHeader: React.FC<{}> = () => {
    return (
        <div style={{ display: 'flex' }} className={`${classes['header']}`}>
            CovChat
        </div>
    );
};
export default SidebarHeader;
